import { Stack } from '@chakra-ui/react';
import { Checkbox } from '@kula-ai/components';
import { useField } from 'formik';

export const CheckboxGroupField = ({ item, field }) => {
  const {
    options,
    name,
    styles,
    checkboxStyles,
    checkboxWrapperStyles,
    checkboxLabelStyles,
    disabled = false,
    editable = true,
  } = item;

  const [formField, , helpers = {}] = useField(name);
  const { setValue } = helpers || {};
  const currentValue = formField.value || [];

  const handleCheckboxChange = (optionValue, isChecked) => {
    if (isChecked) {
      setValue?.([...currentValue, optionValue]);
    } else {
      setValue?.(currentValue.filter((v) => v !== optionValue));
    }
  };

  return (
    <Stack direction="row" ml="5px" {...styles}>
      {options?.map((option) => (
        <Checkbox
          key={option?.value}
          checked={currentValue.includes(option?.value)}
          onChange={(e) => handleCheckboxChange(option?.value, e.target.checked)}
          disabled={disabled || !editable}
          label={option?.label}
          size="md"
        />
      ))}
    </Stack>
  );
};
